import { render, staticRenderFns } from "./ScanBody.vue?vue&type=template&id=dd9147e4&scoped=true&"
import script from "./ScanBody.vue?vue&type=script&lang=js&"
export * from "./ScanBody.vue?vue&type=script&lang=js&"
import style0 from "./ScanBody.vue?vue&type=style&index=0&id=dd9147e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9147e4",
  null
  
)

export default component.exports